const FILE_SIZE_LIMIT = 4e8;
var SupportFileType = /* @__PURE__ */ ((SupportFileType2) => {
  SupportFileType2["ScopeResource"] = "ScopeResource";
  SupportFileType2["ScopeReference"] = "ScopeReference";
  return SupportFileType2;
})(SupportFileType || {});
const getSupportFileRootPath = (requestForm) => {
  var _a, _b;
  return (_b = (_a = requestForm == null ? void 0 : requestForm.AnalysisRequestForm) == null ? void 0 : _a.SupportFilePath) != null ? _b : "";
};
const getSupportFileVariablePath = (requestForm) => {
  return getSupportFileRootPath(requestForm).replace(`\\\\localhost\\ExpAnalysisRC\\Foray\\CustomResourcesV2\\`, "");
};
const getSupportFileForRequest = (fileNameWithVariablePath) => {
  return `https://expanalysisprod.blob.core.windows.net/expanalysis-supportfiles/${fileNameWithVariablePath}`.replace(/\\/g, "/");
};
const getNameFromPath = (path) => {
  var _a;
  return (_a = path == null ? void 0 : path.replace(/^.*[\\/]/, "")) != null ? _a : "";
};
const getSupportFilesForUpload = (files, requestForm) => {
  const supportFiles = files.filter((f) => !!f.file && f.file.size <= FILE_SIZE_LIMIT);
  return supportFiles.map((f) => ({ name: getSupportFileVariablePath(requestForm) + f.name, data: f.file }));
};
const isSupportFileWithinSize = (values) => {
  let errors = {};
  const scopeReferenceFiles = values.scopeReferenceFiles;
  const scopeResourcesFiles = values.scopeResourcesFiles;
  const erroredReferenceFiles = scopeReferenceFiles.filter((f) => {
    var _a, _b;
    return ((_a = f.file) == null ? void 0 : _a.size) ? ((_b = f.file) == null ? void 0 : _b.size) > FILE_SIZE_LIMIT : false;
  });
  const erroredResourcesFiles = scopeResourcesFiles.filter((f) => {
    var _a, _b;
    return ((_a = f.file) == null ? void 0 : _a.size) ? ((_b = f.file) == null ? void 0 : _b.size) > FILE_SIZE_LIMIT : false;
  });
  if (erroredReferenceFiles.length > 0) {
    errors.scopeReferenceFiles = 'The file(s) "' + erroredReferenceFiles.map((f) => f.name).join('", "') + '" exceed size limit of 400MB.';
  }
  if (erroredResourcesFiles.length > 0) {
    errors.scopeResourcesFiles = 'The file(s) "' + erroredResourcesFiles.map((f) => f.name).join('", "') + '" exceed size limit of 400MB.';
  }
  return errors;
};
export {
  FILE_SIZE_LIMIT,
  SupportFileType,
  getNameFromPath,
  getSupportFileForRequest,
  getSupportFileRootPath,
  getSupportFileVariablePath,
  getSupportFilesForUpload,
  isSupportFileWithinSize
};
//# sourceMappingURL=SupportFilesForm.utils.js.map
